(() => {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (motionQuery.matches || !('IntersectionObserver' in window)) return;

  const selectors = [
    ['.pc-product-perspective__intro, .pc-product-specs__intro, .pc-product-routine__intro, .pc-product-faq__intro', 'section'],
    ['.pc-product-perspective__point, .pc-product-specs__item, .pc-product-routine__step, .pc-product-faq__item', 'item'],
    ['.pc-product-routine__note', 'section'],
    ['product-recommendations, product-recommendations .resource-card', 'item'],
  ];

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('pc-motion-is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
  );

  const prepare = (root = document) => {
    let delayIndex = 0;

    selectors.forEach(([selector, type]) => {
      const elements = [...root.querySelectorAll(selector)];
      if (root instanceof HTMLElement && root.matches(selector)) elements.unshift(root);
      elements.forEach((element) => {
        if (!(element instanceof HTMLElement) || element.dataset.pcMotion) return;

        element.dataset.pcMotion = type;
        element.style.setProperty('--pc-motion-delay', `${Math.min(delayIndex * 55, 220)}ms`);
        delayIndex += 1;
        observer.observe(element);
      });
    });
  };

  prepare();
  document.documentElement.classList.add('pc-motion-ready');

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        prepare(node);
        if (node.matches('.resource-card, product-recommendations')) prepare(node.parentElement || document);
      });
    });
  });

  mutationObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  document.addEventListener('focusin', (event) => {
    const target = event.target.closest?.('[data-pc-motion]');
    if (!target) return;
    target.classList.add('pc-motion-is-visible');
    observer.unobserve(target);
  });
  motionQuery.addEventListener('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll('[data-pc-motion]').forEach((element) => element.classList.add('pc-motion-is-visible'));
    observer.disconnect();
    mutationObserver.disconnect();
    document.documentElement.classList.remove('pc-motion-ready');
  });
})();
